var _mask, _path, _circle, _rect;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgThermometer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 25,
    viewBox: "0 0 11 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-1-inside-1_517_6723",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.5 0C3.567 0 2 1.567 2 3.5V15.2572C0.778497 16.266 0 17.7921 0 19.5C0 22.5376 2.46243 25 5.5 25C8.53757 25 11 22.5376 11 19.5C11 17.7921 10.2215 16.266 9 15.2572V3.5C9 1.567 7.433 0 5.5 0Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 15.2572L3.27356 16.7993L4 16.1993V15.2572H2ZM9 15.2572H7V16.1993L7.72644 16.7993L9 15.2572ZM4 3.5C4 2.67157 4.67157 2 5.5 2V-2C2.46243 -2 0 0.462434 0 3.5H4ZM4 15.2572V3.5H0V15.2572H4ZM2 19.5C2 18.4138 2.49238 17.4444 3.27356 16.7993L0.726445 13.7151C-0.935382 15.0875 -2 17.1703 -2 19.5H2ZM5.5 23C3.567 23 2 21.433 2 19.5H-2C-2 23.6421 1.35786 27 5.5 27V23ZM9 19.5C9 21.433 7.433 23 5.5 23V27C9.64214 27 13 23.6421 13 19.5H9ZM7.72644 16.7993C8.50762 17.4444 9 18.4138 9 19.5H13C13 17.1703 11.9354 15.0875 10.2736 13.7151L7.72644 16.7993ZM7 3.5V15.2572H11V3.5H7ZM5.5 2C6.32843 2 7 2.67157 7 3.5H11C11 0.462434 8.53757 -2 5.5 -2V2Z",
    fill: "#464646",
    mask: "url(#path-1-inside-1_517_6723)"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 5.5,
    cy: 19.5,
    r: 2.5,
    fill: "#464646"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 5,
    width: 1,
    height: 13,
    rx: 0.5,
    fill: "#464646"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThermometer);
export default __webpack_public_path__ + "static/media/thermometer.ece88d8c7f94f6ca5e4e53a0c39f2664.svg";
export { ForwardRef as ReactComponent };